import React, { useEffect } from "react";
import { useHomeUrl } from "hooks/firestore/v2/user/usePreferences";
import { PageLoader } from "library";
import { navigate } from "utilities/navigate";
import { useLocation } from "@gatsbyjs/reach-router";
import { useIsClient } from "usehooks-ts";

export const HomePage = () => {
  const isClient = useIsClient();
  const homeUrl = useHomeUrl();
  const { search } = useLocation();

  const prefix = search && search.charAt(0) !== "?" ? "?" : "";
  const params = search ? `${prefix}${search}` : "";

  useEffect(() => {
    if (!isClient) return;

    navigate(`${homeUrl}/${params}`);
  }, [isClient]);

  return <PageLoader />;
};

export default HomePage;
